module.exports = __webpack_public_path__ + "img/type--1-spans--multiple-lang--fr.7b8bdc69.jpg";